export const SET_STATE = 'checkoutPage/paymentOptions/SET_STATE';
export const SET_FETCHING = 'checkoutPage/paymentOptions/SET_FETCHING';
export const SET_PAYMENT_OPTIONS_VALUE = 'checkoutPage/paymentOptions/SET_PAYMENT_OPTIONS_VALUE';
export const SET_SELECTED_PAYMENT_OPTION = 'checkoutPage/paymentOptions/SET_SELECTED_PAYMENT_OPTION';
export const PARTIAL_PAYMET_OPTIONS_REQUEST_PROPERTIES =
  'checkoutPage/paymentOptions/PARTIAL_PAYMET_OPTIONS_REQUEST_PROPERTIES';
export const SET_ALLOWED_PAYMENT_OPTIONS = 'checkoutPage/paymentOptions/SET_ALLOWED_PAYMENT_OPTIONS';
export const RESET_STATE = 'checkoutPage/paymentOptions/RESET_STATE';